const routes = [
  {
    path: "/configuracoes/cidades",
    component: () => import("@/views/configuracoes/cidades/Cidades.vue"),
    meta: {
      menu: "configuracoes",
      title: "Cidades",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.cidade", plural: true },
      ],
      permission: { componente: "Cidades" },
    },
  },
];

export default routes;
